<template>
  <div class="campanha-interna-audiencias-vue mt-3">
    <div class="campanha-interna-audiencias-vue__bootstrap-modals">
      <Modal
        modal-id="modalCampanhaInternaAudienciaPreview"
        title="Usuários na Audiência"
        dialog-class="modal-xl"
      >
        <template #body>
          <div class="campanha-interna-audiencias-vue__preview-body">
            <div class="row campanha-interna-audiencias-vue__preview-hero mb-3">
              <div class="col-6 text-center">
                <div class="campanha-interna-audiencias-vue__preview-hero-num">
                  {{ previewStats.total_usuarios_distintos }}
                </div>
                <div class="campanha-interna-audiencias-vue__preview-hero-label">USUÁRIOS ENCONTRADOS</div>
              </div>
              <div class="col-6 text-center">
                <div class="campanha-interna-audiencias-vue__preview-hero-num">
                  {{ previewStats.total_lojas_distintas }}
                </div>
                <div class="campanha-interna-audiencias-vue__preview-hero-label">EMPRESAS</div>
              </div>
            </div>

            <p
              v-if="previewStats.total_vinculos !== previewStats.total_usuarios_distintos"
              class="text-muted small text-center mb-2"
            >
              Vínculos usuário–loja no total: {{ previewStats.total_vinculos }}
            </p>

            <p v-if="previewStats.amostra_truncada" class="text-muted small text-center mb-3">
              Lista abaixo é uma amostra; há mais registros além dos exibidos.
            </p>

            <div
              v-if="previewGroupedByLoja.length"
              class="campanha-interna-audiencias-vue__preview-list"
            >
              <div
                v-for="grupo in previewGroupedByLoja"
                :key="grupo.loja_id"
                class="campanha-interna-audiencias-vue__preview-loja-card"
              >
                <div class="campanha-interna-audiencias-vue__preview-loja-head">
                  <i class="fas fa-building campanha-interna-audiencias-vue__preview-loja-icon" aria-hidden="true"></i>
                  <div class="flex-grow-1 min-w-0">
                    <div class="campanha-interna-audiencias-vue__preview-loja-title">
                      {{ grupo.loja_nome }} ({{ grupo.loja_id }})
                    </div>
                    <div class="campanha-interna-audiencias-vue__preview-loja-sub">
                      {{ grupo.users.length }}
                      {{ grupo.users.length === 1 ? 'usuário' : 'usuários' }} na amostra
                    </div>
                  </div>
                </div>
                <div class="campanha-interna-audiencias-vue__preview-user-list">
                  <div
                    v-for="(u, ui) in grupo.users"
                    :key="`${grupo.loja_id}-${u.user_id}-${ui}`"
                    class="campanha-interna-audiencias-vue__preview-user-row"
                  >
                    <i class="fas fa-user campanha-interna-audiencias-vue__preview-user-icon" aria-hidden="true"></i>
                    <span class="campanha-interna-audiencias-vue__preview-user-name">{{ u.user_name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <p v-else class="text-muted text-center small mb-0">
              Nenhum destinatário encontrado para esta audiência.
            </p>
          </div>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closePreviewModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCampanhaInternaAudienciaErro"
        :title="errorModalTitle"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="errorModalMessage" class="mb-2">{{ errorModalMessage }}</p>
          <ul
            v-if="errorModalItems.length"
            class="list-unstyled mb-0 campanha-interna-audiencias-vue__error-list"
          >
            <li v-for="(row, i) in errorModalItems" :key="i" class="small">
              <template v-if="row.label">
                <strong>{{ row.label }}:</strong>
                {{ row.text }}
              </template>
              <template v-else>{{ row.text }}</template>
            </li>
          </ul>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeErrorModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCampanhaInternaAudienciaConfirmExcluir"
        title="Excluir audiência"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p class="mb-0">
            Excluir a audiência <strong v-if="deleteTarget">"{{ deleteTarget.nome }}"</strong>?
          </p>
        </template>
        <template #footer>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            :disabled="deleteDeleting"
            @click="executeDelete"
          >
            {{ deleteDeleting ? 'Excluindo…' : 'Excluir' }}
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm ml-2"
            :disabled="deleteDeleting"
            @click="closeConfirmDeleteModal"
          >
            Cancelar
          </button>
        </template>
      </Modal>
    </div>

    <!-- Lista -->
    <div v-if="page === 'list'">
      <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap campanha-interna-audiencias-vue__toolbar">
        <h5 class="mb-0 campanha-interna-audiencias-vue__title"></h5>
        <Button :href="routes.create" variant="success" size="sm" depth>
          <Icon type="fas" icon="plus" color="white" class="mr-1" />
          Adicionar
        </Button>
      </div>

      <div v-if="loading" class="text-center py-4 campanha-interna-audiencias-vue__loading">Carregando...</div>
      <div v-else class="campanha-interna-audiencias-vue__card campanha-interna-audiencias-vue__datatable-wrap">
        <DataTable
          name="Audiências campanhas internas"
          :headers="headers"
          :data="items"
          :pesquisa="true"
          :options="tableOptions"
          :itens-per-page-options="[10, 20, 30, 50, 100, -1]"
        >
          <template v-slot:[`item.status`]="{ item }">
            <span
              class="campanha-interna-vue-status-pill"
              :class="
                isStatusAtivo(item)
                  ? 'campanha-interna-vue-status-pill--ativa'
                  : 'campanha-interna-vue-status-pill--inativa'
              "
            >
              {{ isStatusAtivo(item) ? 'Ativa' : 'Inativa' }}
            </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex justify-content-end align-items-center flex-wrap campanha-interna-audiencias-vue__row-actions">
              <Button
                variant="primary"
                outline
                size="sm"
                table
                class="mr-1 mb-1"
                title="Preview de destinatários (totais e amostra)"
                :loading="testingId === item.id"
                @click="runPreview(item.id)"
              >
                <i class="fas fa-vial"></i>
              </Button>
              <Button
                :href="editUrl(item.id)"
                variant="primary"
                size="sm"
                table
                class="mr-1 mb-1"
                title="Editar"
              >
                <i class="fas fa-edit"></i>
              </Button>
              <Button
                variant="danger"
                size="sm"
                table
                class="mb-1"
                title="Excluir"
                @click="confirmDelete(item)"
              >
                <i class="fas fa-trash"></i>
              </Button>
            </div>
          </template>
        </DataTable>
      </div>
    </div>

    <!-- Formulário -->
    <vuetify-wrapper v-else>
      <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap campanha-interna-audiencias-vue__toolbar">
        <h5 class="mb-0 campanha-interna-audiencias-vue__title"></h5>
        <Button :href="routes.index" variant="cancel" size="sm">Voltar</Button>
      </div>

      <v-card elevation="1" class="campanha-interna-audiencias-vue__card">
        <v-card-text>
          <Input
            v-model="form.nome"
            name="nome"
            id="campanha-interna-audiencia-nome"
            label="Nome"
            placeholder="Nome da audiência"
            required
          />

          <div class="mb-4">
            <Check v-model="form.status">
              Ativo
            </Check>
          </div>

          <v-divider class="my-4" />

          <h6 class="subtitle-1 mb-2 campanha-interna-audiencias-vue__section-title">Loja — módulos</h6>
          <p class="text-caption mb-3 campanha-interna-audiencias-vue__hint">
            Indiferente não restringe. Sim ou Não exige que a loja atenda (ou não) ao módulo ou ao flag indicado.
          </p>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-modulo-crm">Módulo CRM</label>
            <RadioGroup
              v-model="form.modulo_crm"
              name="filtro_modulo_crm"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-modulo-crm"
            />
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-modulo-ecommerce">Módulo E-commerce</label>
            <RadioGroup
              v-model="form.modulo_ecommerce"
              name="filtro_modulo_ecommerce"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-modulo-ecommerce"
            />
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-usa-erp-eloca">Utiliza ERP</label>
            <RadioGroup
              v-model="form.usa_erp_eloca"
              name="filtro_usa_erp_eloca"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-usa-erp-eloca"
            />
          </div>

          <v-divider class="my-4" />

          <h6 class="subtitle-1 mb-2 campanha-interna-audiencias-vue__section-title">Integrações</h6>
          <p class="text-caption mb-2 campanha-interna-audiencias-vue__hint">A loja deve ter todas as integrações marcadas.</p>
          <Check
            v-for="opt in integracaoOpcoes"
            :key="opt.value"
            v-model="form.integracoes"
            :option-value="opt.value"
            class="mb-2"
          >
            {{ opt.text }}
          </Check>

          <v-divider class="my-4" />

          <h6 class="subtitle-1 mb-2 campanha-interna-audiencias-vue__section-title">Loja — critérios adicionais</h6>
          <p class="text-caption mb-3 campanha-interna-audiencias-vue__hint">
            Indiferente não restringe. Sim ou Não exige que a loja atenda (ou não) ao critério.
          </p>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-tem-config-pagamento">Configuração de pagamento (Iugu ativa)</label>
            <RadioGroup
              v-model="form.tem_config_pagamento"
              name="filtro_tem_config_pagamento"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-tem-config-pagamento"
            />
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-usa-campanha-whatsapp">Campanhas de marketing via WhatsApp</label>
            <RadioGroup
              v-model="form.usa_campanha_whatsapp"
              name="filtro_usa_campanha_whatsapp"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-usa-campanha-whatsapp"
            />
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-usa-clicksign">Contrato no checkout (Clicksign)</label>
            <RadioGroup
              v-model="form.usa_clicksign"
              name="filtro_usa_clicksign"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-usa-clicksign"
            />
          </div>

          <div class="mb-3">
            <label class="small d-block mb-1" id="label-usa-datavalid">Datavalid (nível &gt; 0)</label>
            <RadioGroup
              v-model="form.usa_datavalid"
              name="filtro_usa_datavalid"
              :options="filtroSimNaoOptions"
              :inline="false"
              ariaLabelledby="label-usa-datavalid"
            />
          </div>

          <v-divider class="my-4" />

          <h6 class="subtitle-1 mb-2 campanha-interna-audiencias-vue__section-title">Perfil do usuário (na loja)</h6>
          <p class="text-caption mb-2 campanha-interna-audiencias-vue__hint">Se vazio, todos os perfis entram.</p>
          <Autocomplete
            v-model="groupSelectionSync"
            name="group_ids"
            label="Perfis"
            placeholder="Selecione os perfis"
            :items="grupoItems"
            :multiple="true"
            classe="mb-0"
          />

          <h6 class="subtitle-1 mb-2 mt-4 campanha-interna-audiencias-vue__section-title">Nicho da loja</h6>
          <p class="text-caption mb-2 campanha-interna-audiencias-vue__hint">Se vazio, todos os nichos entram.</p>
          <Autocomplete
            v-model="nichoSelectionSync"
            name="nicho_ids"
            label="Nichos"
            placeholder="Selecione os nichos"
            :items="nichoItems"
            :multiple="true"
            classe="mb-0"
          />
        </v-card-text>

        <v-card-actions class="px-4 pb-4 flex-wrap campanha-interna-audiencias-vue__actions">
          <Button variant="primary" depth :loading="saving" @click="submitForm">Salvar</Button>
        </v-card-actions>
      </v-card>
    </vuetify-wrapper>
  </div>
</template>

<script>
import axios from 'axios';

import DataTable from '../ui/DataTable.vue';
import Input from '../ui/Input.vue';
import Check from '../ui/Check.vue';
import RadioGroup from '../ui/RadioGroup.vue';
import Autocomplete from '../ui/Autocomplete.vue';
import Icon from '../ui/Icon.vue';
import Button from '../ui/Button.vue';
import Modal from '../ui/Modal.vue';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};

/** Evita seguir redirect com PUT/POST (405 no index). */
const axiosSaveOptions = {
  headers: jsonHeaders,
  maxRedirects: 0,
};

function audienciaFieldLabel(key) {
  const map = {
    nome: 'Nome',
    status: 'Status',
    modulo_crm: 'Módulo CRM',
    modulo_ecommerce: 'Módulo e-commerce',
    integracoes: 'Integrações',
    group_ids: 'Grupos de usuários',
    nicho_ids: 'Nichos',
    tem_config_pagamento: 'Configuração de pagamento',
    usa_campanha_whatsapp: 'Campanha WhatsApp',
    usa_erp_eloca: 'ERP Eloca',
    usa_clicksign: 'Clicksign',
    usa_datavalid: 'Datavalid',
  };
  return map[key] || String(key).replace(/_/g, ' ');
}

function csrf() {
  const m = document.querySelector('meta[name="csrf-token"]');
  return m ? m.getAttribute('content') : '';
}

export default {
  name: 'CampanhaInternaAudienciasApp',
  components: {
    DataTable,
    Input,
    Check,
    RadioGroup,
    Autocomplete,
    Icon,
    Button,
    Modal,
  },
  data() {
    return {
      page: 'list',
      loading: false,
      saving: false,
      testingId: null,
      items: [],
      audienciaId: null,
      routes: {},
      tableOptions: {
        page: 1,
        itemsPerPage: 30,
      },
      form: {
        nome: '',
        status: true,
        modulo_crm: '',
        modulo_ecommerce: '',
        integracoes: [],
        group_ids: [],
        nicho_ids: [],
        tem_config_pagamento: '',
        usa_campanha_whatsapp: '',
        usa_erp_eloca: '',
        usa_clicksign: '',
        usa_datavalid: '',
      },
      grupoItems: [],
      nichoItems: [],
      /** Evita computed que recria array a cada render (loop com v-autocomplete). */
      groupSelectionSync: [],
      nichoSelectionSync: [],
      /** Evita loop ao hidratar Autocomplete após GET / audiência */
      _suppressSelectionWatch: false,
      errorModalTitle: 'Atenção',
      errorModalMessage: '',
      errorModalItems: [],
      deleteTarget: null,
      deleteDeleting: false,
      previewStats: {
        total_vinculos: 0,
        total_usuarios_distintos: 0,
        total_lojas_distintas: 0,
        amostra_truncada: false,
      },
      previewRows: [],
      headers: [
        { text: '#', value: 'id', sortable: true, width: '72px' },
        { text: 'Nome', value: 'nome', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Ações', value: 'actions', sortable: false, align: 'end', width: '168px' },
      ],
      integracaoOpcoes: [
        { value: 'gupshup', text: 'WhatsApp (Gupshup / Hyperflow)' },
        { value: 'websocket', text: 'WhatsApp WebSocket' },
        { value: 'facebook', text: 'Facebook' },
        { value: 'instagram', text: 'Instagram' },
        { value: 'email_smtp', text: 'E-mail' },
        { value: 'telefonia', text: 'Telefonia' },
      ],
      filtroSimNaoOptions: [
        { value: '', label: 'Indiferente' },
        { value: '1', label: 'Sim' },
        { value: '0', label: 'Não' },
      ],
    };
  },
  computed: {
    /** Agrupa a amostra por loja para o layout em cards (referência visual). */
    previewGroupedByLoja() {
      const rows = this.previewRows || [];
      const map = new Map();
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const lid = row.loja_id;
        if (!map.has(lid)) {
          map.set(lid, {
            loja_id: lid,
            loja_nome: row.loja_nome || '—',
            users: [],
          });
        }
        map.get(lid).users.push(row);
      }
      return Array.from(map.values()).sort((a, b) =>
        String(a.loja_nome).localeCompare(String(b.loja_nome), 'pt-BR', { sensitivity: 'base' })
      );
    },
  },
  watch: {
    groupSelectionSync: {
      deep: true,
      handler(val) {
        if (this._suppressSelectionWatch) return;
        const ids = (val || []).map((o) => o.id);
        if (JSON.stringify(ids) === JSON.stringify(this.form.group_ids || [])) return;
        this.form.group_ids = ids;
      },
    },
    nichoSelectionSync: {
      deep: true,
      handler(val) {
        if (this._suppressSelectionWatch) return;
        const ids = (val || []).map((o) => o.id);
        if (JSON.stringify(ids) === JSON.stringify(this.form.nicho_ids || [])) return;
        this.form.nicho_ids = ids;
      },
    },
  },
  mounted() {
    const cfg = window.campanhaInternaAudienciasConfig || {};
    this.routes = cfg.routes || {};
    this.page = cfg.page === 'form' ? 'form' : 'list';
    this.audienciaId = cfg.audienciaId != null ? Number(cfg.audienciaId) : null;
    this.grupoItems = (cfg.meta?.grupos || []).map((g) => ({ id: g.id, value: g.value }));
    this.nichoItems = (cfg.meta?.nichos || []).map((n) => ({ id: n.id, value: n.value }));

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf();

    if (this.page === 'list') {
      this.loadList();
    } else if (this.audienciaId) {
      this.loadAudiencia();
    } else {
      this.groupSelectionSync = [];
      this.nichoSelectionSync = [];
    }
  },
  methods: {
    isStatusAtivo(item) {
      const s = item && item.status;
      if (s === true || s === 1 || s === '1') return true;
      if (s === false || s === 0 || s === '0') return false;
      return !!s;
    },
    editUrl(id) {
      return `${this.routes.base}/${id}/edit`;
    },
    showErrorModal({ title, message, errors }) {
      this.errorModalTitle = title || 'Atenção';
      this.errorModalMessage = message || '';
      this.errorModalItems = [];
      if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
        Object.keys(errors).forEach((key) => {
          const msgs = errors[key];
          const arr = Array.isArray(msgs) ? msgs : [msgs];
          const label = audienciaFieldLabel(key);
          arr.forEach((m) => {
            if (m != null && String(m).trim() !== '') {
              this.errorModalItems.push({ label, text: String(m) });
            }
          });
        });
      }
      if (!this.errorModalMessage && this.errorModalItems.length) {
        this.errorModalMessage = 'Corrija os campos indicados abaixo.';
      }
      this.$nextTick(() => {
        $('#modalCampanhaInternaAudienciaErro').modal('show');
      });
    },
    closeErrorModal() {
      $('#modalCampanhaInternaAudienciaErro').modal('hide');
    },
    openPreviewModal() {
      this.$nextTick(() => {
        $('#modalCampanhaInternaAudienciaPreview').modal('show');
      });
    },
    closePreviewModal() {
      $('#modalCampanhaInternaAudienciaPreview').modal('hide');
    },
    openConfirmDeleteModal() {
      this.$nextTick(() => {
        $('#modalCampanhaInternaAudienciaConfirmExcluir').modal('show');
      });
    },
    closeConfirmDeleteModal() {
      $('#modalCampanhaInternaAudienciaConfirmExcluir').modal('hide');
      this.deleteTarget = null;
    },
    async loadList() {
      this.loading = true;
      try {
        const { data } = await axios.get(this.routes.indexJson, {
          params: { per_page: 500 },
          headers: jsonHeaders,
        });
        this.items = data.data || [];
      } catch (e) {
        console.error(e);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    async loadAudiencia() {
      this.loading = true;
      try {
        const { data } = await axios.get(`${this.routes.base}/${this.audienciaId}`, { headers: jsonHeaders });
        this.form.nome = data.nome || '';
        this.form.status = !!data.status;
        const f = data.filtros || {};
        this.form.modulo_crm = f.modulo_crm != null ? String(f.modulo_crm) : '';
        this.form.modulo_ecommerce = f.modulo_ecommerce != null ? String(f.modulo_ecommerce) : '';
        if (this.form.modulo_crm === '' && this.form.modulo_ecommerce === '' && Array.isArray(f.loja_modulos)) {
          const lm = f.loja_modulos;
          this.form.modulo_crm = lm.includes('crm') ? '1' : '';
          this.form.modulo_ecommerce = lm.includes('ecommerce') ? '1' : '';
        }
        this.form.integracoes = [...(f.integracoes || [])];
        this.form.group_ids = [...(f.group_ids || [])];
        this.form.nicho_ids = [...(f.nicho_ids || [])];
        this.form.tem_config_pagamento = f.tem_config_pagamento != null ? String(f.tem_config_pagamento) : '';
        this.form.usa_campanha_whatsapp = f.usa_campanha_whatsapp != null ? String(f.usa_campanha_whatsapp) : '';
        this.form.usa_erp_eloca = f.usa_erp_eloca != null ? String(f.usa_erp_eloca) : '';
        this.form.usa_clicksign = f.usa_clicksign != null ? String(f.usa_clicksign) : '';
        this.form.usa_datavalid = f.usa_datavalid != null ? String(f.usa_datavalid) : '';
        this._suppressSelectionWatch = true;
        this.groupSelectionSync = (this.form.group_ids || []).map((id) => {
          const found = this.grupoItems.find((g) => g.id === id);
          return found || { id, value: `#${id}` };
        });
        this.nichoSelectionSync = (this.form.nicho_ids || []).map((id) => {
          const found = this.nichoItems.find((n) => n.id === id);
          return found || { id, value: `#${id}` };
        });
        this.$nextTick(() => {
          this._suppressSelectionWatch = false;
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async submitForm() {
      this.saving = true;
      const payload = {
        nome: this.form.nome,
        status: this.form.status,
        modulo_crm: this.form.modulo_crm,
        modulo_ecommerce: this.form.modulo_ecommerce,
        integracoes: this.form.integracoes,
        group_ids: this.form.group_ids,
        nicho_ids: this.form.nicho_ids,
        tem_config_pagamento: this.form.tem_config_pagamento,
        usa_campanha_whatsapp: this.form.usa_campanha_whatsapp,
        usa_erp_eloca: this.form.usa_erp_eloca,
        usa_clicksign: this.form.usa_clicksign,
        usa_datavalid: this.form.usa_datavalid,
      };
      try {
        let res;
        if (this.audienciaId) {
          res = await axios.put(`${this.routes.base}/${this.audienciaId}`, payload, axiosSaveOptions);
        } else {
          res = await axios.post(this.routes.store, payload, axiosSaveOptions);
        }
        const raw = res.data && res.data.redirect ? res.data.redirect : this.routes.index;
        let next = raw;
        if (raw && !String(raw).match(/^https?:\/\//i)) {
          try {
            next = new URL(raw, window.location.origin).href;
          } catch (err) {
            next = this.routes.index;
          }
        }
        window.location.assign(next);
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 422) {
          this.showErrorModal({
            title: 'Dados inválidos',
            message: d.message || 'Os dados enviados são inválidos.',
            errors: d.errors,
          });
        } else {
          this.showErrorModal({
            title: 'Não foi possível salvar',
            message:
              (typeof d.message === 'string' && d.message) ||
              (e.message && String(e.message)) ||
              'Não foi possível salvar. Tente novamente.',
          });
        }
      } finally {
        this.saving = false;
      }
    },
    async runPreview(id) {
      if (!id) return;
      this.testingId = id;
      try {
        const { data } = await axios.get(`${this.routes.base}/${id}/preview`, {
          headers: jsonHeaders,
        });
        this.previewStats = {
          total_vinculos: data.total_vinculos ?? 0,
          total_usuarios_distintos: data.total_usuarios_distintos ?? 0,
          total_lojas_distintas: data.total_lojas_distintas ?? 0,
          amostra_truncada: !!data.amostra_truncada,
        };
        this.previewRows = Array.isArray(data.amostra) ? data.amostra : [];
        this.openPreviewModal();
      } catch (e) {
        this.showErrorModal({
          title: 'Preview da audiência',
          message: 'Não foi possível carregar o preview da audiência.',
        });
      } finally {
        this.testingId = null;
      }
    },
    confirmDelete(item) {
      this.deleteTarget = item;
      this.deleteDeleting = false;
      this.openConfirmDeleteModal();
    },
    async executeDelete() {
      if (!this.deleteTarget) {
        this.closeConfirmDeleteModal();
        return;
      }
      const id = this.deleteTarget.id;
      this.deleteDeleting = true;
      try {
        await axios.delete(`${this.routes.base}/${id}`, { headers: jsonHeaders });
        this.closeConfirmDeleteModal();
        this.loadList();
      } catch (e) {
        this.closeConfirmDeleteModal();
        const d = e.response && e.response.data ? e.response.data : {};
        this.showErrorModal({
          title: 'Exclusão',
          message:
            (typeof d.message === 'string' && d.message) ||
            'Não foi possível excluir esta audiência.',
        });
      } finally {
        this.deleteDeleting = false;
      }
    },
  },
};
</script>

<style scoped>
.campanha-interna-audiencias-vue__error-list li + li {
  margin-top: 0.35rem;
}
</style>
